import { render, staticRenderFns } from "./WeeksGroupS1Ranking.vue?vue&type=template&id=31e308df&"
import script from "./WeeksGroupS1Ranking.vue?vue&type=script&lang=js&"
export * from "./WeeksGroupS1Ranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports